@for (option of visibleOptions; track option; let i = $index) {
  <div
    (click)="pick(i)"
    [ngClass]="{ active: option.picked }"
    class="option"
    >
    <svg viewBox="0 0 400 400">
      <rect
        [attr.height]="option.height"
        [attr.width]="option.width / (type==='Triplex'?1:2)"
        [attr.x]="(400 - option.width/ (type==='Triplex'?1:2)) / 2"
        [attr.y]="(400 - option.height) / 2"
        fill="none"
        stroke="#ccc"
      ></rect>
      <rect
        [attr.height]="option.height"
        [attr.width]="10"
        [attr.x]="(400 - option.width / (type==='Triplex'?1:2)) / 2 - 10"
        [attr.y]="(400 - option.height) / 2"
        fill="none"
        stroke="#ccc"
      ></rect>
    </svg>
    {{ option.label | langPicker | async }}
  </div>
}
